import { backendApi } from './api'

// Service-laget for kunde-objektet (`/api/customers`). Bruker eksisterende
// axios-instans med autentisering og caching.

export async function listCustomers({ search = '', active = '1' } = {}) {
  const { data } = await backendApi.get('/customers', { params: { search, active } })
  return data.customers || []
}

export async function getCustomer(id) {
  const { data } = await backendApi.get(`/customers/${id}`)
  return data
}

export async function createCustomer(payload) {
  const { data } = await backendApi.post('/customers', payload)
  return data
}

export async function updateCustomer(id, payload) {
  const { data } = await backendApi.put(`/customers/${id}`, payload)
  return data
}

export async function updateCustomerBillingSettings(id, payload) {
  const { data } = await backendApi.put(
    `/customers/${id}/billing-settings`,
    payload,
  )
  return data
}

export async function deactivateCustomer(id) {
  const { data } = await backendApi.delete(`/customers/${id}`)
  return data
}

// Kobler kunden til Tripletex: finner den der på orgnr, eller oppretter den.
// Svaret har handling 'koblet' eller 'opprettet', tripletex_id og eventuelt warning.
export async function syncCustomerToTripletex(id) {
  const { data } = await backendApi.post(`/customers/${id}/sync-tripletex`)
  return data
}

export async function listIntegrations(customerId) {
  const { data } = await backendApi.get(`/customers/${customerId}/integrations`)
  return data.integrations || []
}

export async function createIntegration(customerId, payload) {
  const { data } = await backendApi.post(`/customers/${customerId}/integrations`, payload)
  return data
}

export async function updateIntegration(customerId, integrationId, payload) {
  const { data } = await backendApi.put(`/customers/${customerId}/integrations/${integrationId}`, payload)
  return data
}

export async function deleteIntegration(customerId, integrationId) {
  const { data } = await backendApi.delete(`/customers/${customerId}/integrations/${integrationId}`)
  return data
}

// --- Modul 3: kundebrukere (rolle 'kunde' bundet til denne kunden) ---
export async function inviteCustomerUser(customerId, { email, name }) {
  const { data } = await backendApi.post('/auth/users', {
    email, name, role: 'kunde', customer_id: customerId,
  })
  return data
}

// --- Modul 13: kontaktpersoner ---
export async function listCustomerContacts(customerId) {
  const { data } = await backendApi.get(`/customers/${customerId}/contacts`)
  return data.contacts || []
}

export async function createCustomerContact(customerId, payload) {
  const { data } = await backendApi.post(`/customers/${customerId}/contacts`, payload)
  return data
}

export async function updateCustomerContact(customerId, contactId, payload) {
  const { data } = await backendApi.put(`/customers/${customerId}/contacts/${contactId}`, payload)
  return data
}

export async function deleteCustomerContact(customerId, contactId) {
  const { data } = await backendApi.delete(`/customers/${customerId}/contacts/${contactId}`)
  return data
}

// Betalingsfristen ligger på kunden i Tripletex (invoicesDueIn), ikke på
// ordren. Uten dette oppslaget kan ikke UI-et si at Pulse og Tripletex spriker.
export async function getCustomerPaymentTerms(id) {
  const { data } = await backendApi.get(`/customers/${id}/payment-terms`, {
    cache: false,
  })
  return data
}

// Samlefaktura (singleCustomerInvoice) ligger på kunden i Tripletex og leses
// derfra hver gang. Tripletex er fasit.
export async function getCustomerSingleInvoice(id) {
  const { data } = await backendApi.get(`/customers/${id}/single-customer-invoice`, {
    cache: false,
  })
  return data
}

export async function setCustomerSingleInvoice(id, enabled) {
  const { data } = await backendApi.put(`/customers/${id}/single-customer-invoice`, { enabled })
  return data
}
